import { render, staticRenderFns } from "./PageListBlock.vue?vue&type=template&id=c668ce30"
import script from "./PageListBlock.vue?vue&type=script&lang=js"
export * from "./PageListBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports